import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './views/router.js';
import App from './App';
import store from './store';
import VueBrowserUpdate from '@sum.cumo/vue-browserupdate';

Vue.use(VueBrowserUpdate, {
    options: {
        container: document.body,
        required: {
            e: 15,
            f: 22,
            o: 22,
            s: 9,
            c: 35
        },
        reminder: 24,
        text: "erreur"
    },
    test: false,
});

Vue.use(VueRouter);
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: '#appcompetences',
    router,
    store,
    render: h => h(App)
});

// Si l'application est chargée dans une iFrame
if (window.parent !== window) {

    // Écoute les mutations pour envoyer des messages à la fenêtre parent
    var observer = new MutationObserver(function () {
        window.parent.postMessage({
            message: 'appcompetences:mutate'
        }, window.location.origin);
    }.bind(document));

    // L'élément à observer
    observer.observe(
      document.getElementById('appcompetences--widget'),
      {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
      }
    );

    // La fenêtre parente est prévenu quand l'application est prête
    document.addEventListener('readystatechange', function () {
        if (document.readyState === 'complete') {
            window.parent.postMessage({
                message: 'appcompetences:ready'
            }, window.location.origin);
        }
    });
}